import type { WizardTravelAdditionalData } from 'BrokerTsLib/src/dtos'
import { useContext } from 'react'
import { useNavigate } from 'react-router'

import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step4Form } from '../../../containers/cestovko/Step4Form'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { StepsContent } from '../../../context/StepsContext'
import { useSaveStep4, useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'

export const Step4 = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId, refetchInsuranceParams } = useContext(insuranceParamsContext)
  const { mutateAsync: saveStep4 } = useSaveStep4()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()

  const handleSubmit = (values: WizardTravelAdditionalData) =>
    saveStep4(values)
      .then((response) => {
        if (values.nextPage == 'next') {
          if ((insuranceParams?.generalParams.lastWizardStep ?? 4) < 5) {
            updateStep({ paramsId: Number(insuranceParamsId), step: 5 }).then(() => refetchInsuranceParams())
          }
          else {
            refetchInsuranceParams()
          }

          navigate(`/cestovko/wizard/5/${insuranceParamsId}`)
        } else {
          refetchInsuranceParams()
          window.scrollTo(0, 0)
        }

        return response
      })

  return (
    <Section>
      <Container>
        <StepsContent step={4}>
          <Steps icon="beach" />

          <InsuranceInfo />

          <Step4Form onSubmit={handleSubmit} />
        </StepsContent>

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
